/**
 * Shared misc utilities module for SMG
 */
(function() {
  angular.module('smg.utils', [])

  .service('smgUtils', [
    function() {
      // Parse a string ID into an int if possible, otherwise leave it unchanged
      this.parseId = function(id) {
        var intId;
        if (typeof id === 'string') {
          intId = parseInt(id, 10);
          if (!isNaN(intId)) {
            return intId;
          } else if (id !== '') {
            return id;
          } else {
            // Treat an empty string as null
            return null;
          }
        } else {
          return id;
        }
      };

      this.parseBoolean = function(value) {
        switch (value) {
          case true:
          case 1:
          case "true":
          case "1":
          case "yes":
            return true;

          case false:
          case 0:
          case "false":
          case "0":
          case "no":
            return false;

          default:
            return null;
        }
      };
    }
  ]);
}).call(this);
